
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prepare-for-competitions/masterclasses",
      function () {
        return require("private-next-pages/prepare-for-competitions/masterclasses.tsx");
      }
    ]);
  